"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _propTypes2 = require("../helpers/prop-types");
var _reactVis = require("react-vis");
var _empty = require("./empty");
var _colors = require("../helpers/colors");
require("react-vis/dist/style.css");
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var defaultColorScale = (0, _colors.colorScaleCategorical)();
var RadarChart = /*#__PURE__*/function (_Component) {
  _inherits(RadarChart, _Component);
  var _super = _createSuper(RadarChart);
  function RadarChart() {
    var _this;
    _classCallCheck(this, RadarChart);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      hoveredValue: undefined
    });
    _defineProperty(_assertThisInitialized(_this), "_renderTooltip", function (formattedData, domains) {
      var _this$props = _this.props,
        data = _this$props.data,
        tooltipRenderer = _this$props.tooltipRenderer,
        tooltipExtraRow = _this$props.tooltipExtraRow;
      var hoveredValue = _this.state.hoveredValue;
      var labels = data.map(function (d) {
        return d.k;
      });
      var tooltipValues = hoveredValue !== undefined ? formattedData.filter(function (item) {
        return item.name === hoveredValue.name;
      })[0] : {};
      return hoveredValue ? /*#__PURE__*/_react.default.createElement(_reactVis.Hint, {
        value: hoveredValue
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "rv-hint__content"
      }, tooltipRenderer ? tooltipRenderer(tooltipValues) : /*#__PURE__*/_react.default.createElement("table", null, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
        colSpan: 3
      }, /*#__PURE__*/_react.default.createElement("strong", null, tooltipValues.name)))), /*#__PURE__*/_react.default.createElement("tbody", null, labels.map(function (label, i) {
        var value = tooltipValues[label];
        var valueText = 'tickFormat' in domains[i] ? domains[i].tickFormat(value) : value;
        return /*#__PURE__*/_react.default.createElement("tr", {
          key: i
        }, /*#__PURE__*/_react.default.createElement("td", null, label), /*#__PURE__*/_react.default.createElement("td", null, valueText));
      })), tooltipExtraRow && /*#__PURE__*/_react.default.createElement("tfoot", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
        colSpan: 3
      }, (0, _isFunction.default)(tooltipExtraRow) ? tooltipExtraRow(tooltipValues) : tooltipExtraRow)))))) : null;
    });
    _defineProperty(_assertThisInitialized(_this), "_processData", function () {
      var _this$props2 = _this.props,
        data = _this$props2.data,
        colorMap = _this$props2.colorMap;
      var getColor = function getColor(k) {
        return colorMap ? colorMap[k] : defaultColorScale(k);
      };
      var obj = {};
      data.forEach(function (d) {
        var k = d.k,
          v = d.v;
        v.forEach(function (d2) {
          var k2 = d2.k,
            v2 = d2.v;
          if (k2 in obj === false) {
            var color = getColor(k2);
            obj[k2] = {
              fill: color,
              stroke: color
            };
          }
          obj[k2][k] = v2;
        });
      });
      return Object.keys(obj).map(function (k) {
        return Object.assign({}, {
          name: k
        }, obj[k]);
      });
    });
    return _this;
  }
  _createClass(RadarChart, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        data = _this$props3.data,
        width = _this$props3.width,
        height = _this$props3.height,
        margin = _this$props3.margin,
        startingAngle = _this$props3.startingAngle,
        labelAttrs = _this$props3.labelAttrs,
        tickFormat = _this$props3.tickFormat,
        gridLineTotal = _this$props3.gridLineTotal;
      var formattedData = this._processData();
      var labels = data.map(function (d) {
        return d.k;
      });
      var domains = labels.map(function (label) {
        var name = label;
        var attrs = {
          name: name
        };
        if (label in labelAttrs) {
          if ('domain' in labelAttrs[label]) {
            attrs.domain = labelAttrs[label].domain;
          }
          var format = 'format' in labelAttrs[label] ? labelAttrs[label].format : null;
          var domainLabels = 'domainLabels' in labelAttrs[label] ? labelAttrs[label].domainLabels : null;
          var _tickFormat = null;
          if (format && domainLabels) {
            _tickFormat = function _tickFormat(v, i) {
              return format(domainLabels[i]);
            };
          } else if (format) {
            _tickFormat = function _tickFormat(v) {
              return format(v);
            };
          } else if (domainLabels) {
            _tickFormat = function _tickFormat(v) {
              return domainLabels[Math.round(v)];
            };
          }
          if (_tickFormat) {
            attrs.tickFormat = _tickFormat;
          }
        }
        attrs.getValue = function (d) {
          return d[name];
        };
        return attrs;
      });
      return /*#__PURE__*/_react.default.createElement(_reactVis.RadarChart, {
        data: formattedData,
        width: width,
        height: height,
        margin: margin,
        tickFormat: tickFormat,
        domains: domains,
        startingAngle: startingAngle,
        onSeriesMouseOver: function onSeriesMouseOver(data) {
          return _this2.setState({
            hoveredValue: data.event[0]
          });
        },
        onSeriesMouseOut: function onSeriesMouseOut() {
          return _this2.setState({
            hoveredValue: undefined
          });
        },
        style: {
          polygons: {
            strokeWidth: 1,
            strokeOpacity: 0.3,
            fillOpacity: 0.3
          },
          labels: {
            textAnchor: 'middle',
            fontSize: "0.9em",
            dominantBaseline: "central"
          },
          axes: {
            line: {
              strokeWidth: 0.8,
              strokeOpacity: 0.8
            },
            text: {
              textAnchor: 'middle',
              fillOpacity: 0.8
            }
          }
        }
      }, /*#__PURE__*/_react.default.createElement(_reactVis.CircularGridLines, {
        tickTotal: gridLineTotal,
        rRange: [0, (width - margin.left - margin.right) / 2],
        style: {
          strokeWidth: 0.8,
          strokeOpacity: 0.8,
          fill: "transparent"
        }
      }), this._renderTooltip(formattedData, domains));
    }
  }]);
  return RadarChart;
}(_react.Component);
_defineProperty(RadarChart, "propTypes", {
  data: _propTypes2.propTypeGroupedSeries.isRequired,
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  margin: _propTypes2.propTypeMargin,
  colorMap: _propTypes.default.object,
  startingAngle: _propTypes.default.number,
  labelAttrs: _propTypes.default.object,
  tickFormat: _propTypes.default.func,
  gridLineTotal: _propTypes.default.number,
  tooltipExtraRow: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element, _propTypes.default.func]),
  tooltipRenderer: _propTypes.default.func
});
_defineProperty(RadarChart, "defaultProps", {
  width: 400,
  height: 300,
  margin: {
    left: 40,
    right: 40,
    top: 40,
    bottom: 40
  },
  startingAngle: Math.PI / 2,
  labelAttrs: {},
  tickFormat: function tickFormat(t) {
    return t;
  },
  gridLineTotal: 10
});
var _default = (0, _empty.withEmptyView)(RadarChart);
exports.default = _default;